import type { FC } from 'react';
import type { ModelVolatilitySurfaceProps } from './types';
import ModelVolatilitySurfaceWidget from './model-volatility-surface-widget';
import { ModelVolatilitySurfaceProvider } from '../../../../providers/model-volatility-surface-provider';
import { GetVolProvider } from '../../../../providers/get-vol-provider';

const ModelVolatilitySurfaceWrapperProvider: FC<ModelVolatilitySurfaceProps> = (props) => (
  <GetVolProvider providerKey={props.providerKey}>
    <ModelVolatilitySurfaceProvider providerKey={props.providerKey}>
      <ModelVolatilitySurfaceWidget {...props} />
    </ModelVolatilitySurfaceProvider>
  </GetVolProvider>
);

export default ModelVolatilitySurfaceWrapperProvider;
